import { useState } from 'react';

import styles from './styles.module.scss';

const RoomSelector = ({
  roomTypes,
  roomTypeSelection,
  state,
  closeDialog,
  activeElementRef,
  isTutorialMode,
  t,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const getIsActive = (room) => {
    return state.roomKey === room.key;
  };

  const currentRoom =
    roomTypes.find((room) => room.key === state.roomKey) || {};

  const handleRoomSelect = (key) => {
    setIsExpanded(!isExpanded);
    roomTypeSelection(key);
    closeDialog();
  };

  return (
    <nav
      className={styles.nav}
      style={{ zIndex: isTutorialMode ? 'auto' : '10' }}
    >
      <div
        className={styles.current}
        onClick={() => setIsExpanded(!isExpanded)}
        ref={isTutorialMode ? activeElementRef : null}
        style={{
          zIndex: isTutorialMode ? '1000' : '5',
          pointerEvents: isTutorialMode ? 'none' : 'auto',
        }}
      >
        <span>{t(currentRoom.title)}</span>
        <button
          className={`${styles.nav__expandButton} ${
            isExpanded ? styles['nav__expandButton--expanded'] : ''
          }`}
        ></button>
      </div>

      {/* mobile menu  */}
      <ul
        className={styles.nav__menuMobile}
        style={{ display: isExpanded ? 'block' : 'none' }}
      >
        {roomTypes.map(
          (room, idx) =>
            room !== currentRoom && (
              <li
                key={idx}
                className={getIsActive(room) ? styles.active : ''}
                onClick={() => handleRoomSelect(room.key)}
              >
                <span>{t(room.title)}</span>
              </li>
            )
        )}
      </ul>
      {/* desktop menu  */}
      <ul className={styles.nav__menuDesktop}>
        {roomTypes.map((room, idx) => (
          <li
            ref={getIsActive(room) && isTutorialMode ? activeElementRef : null}
            key={idx}
            className={getIsActive(room) ? styles.active : ''}
            onClick={() => handleRoomSelect(room.key)}
            style={{
              zIndex: isTutorialMode && getIsActive(room) ? '1000' : '5',
              pointerEvents: isTutorialMode ? 'none' : 'auto',
            }}
          >
            <span>{t(room.title)}</span>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default RoomSelector;
